import { Box, Grid, Typography, useTheme } from '@mui/material';

import { DEFAULT_BORDER } from 'src/constants';
import { IUserTypesProps } from 'src/types/edit-user';

const UserTypes = ({ hierarchyLevel, partner, partnerOfPartner }: IUserTypesProps) => {
    const theme = useTheme();

    return (
        <Grid
            item
            xs={12}
            sx={{
                ...DEFAULT_BORDER,
                backgroundColor: '#FFFFFF',
                boxShadow: '0px 4px 20px rgba(38, 50, 56, 0.1)',
                padding: '32px 24px',
            }}
            gap={2}
            container
        >
            {/* Heading */}
            <Grid item xs={12} sx={{ borderBottom: '1px solid #F18F34' }}>
                <Box display="flex" flexDirection="column" gap="8px" marginBottom="8px">
                    <Typography variant="h2">User Types</Typography>
                    <Typography>Add new user details in this section</Typography>
                </Box>
            </Grid>

            {/* User Types */}
            <Grid item xs={12} spacing={2} container>
                {/* Hierarchy Level */}
                <Grid item lg={6} xs={12} display="flex" flexDirection="column" gap="24px">
                    <Typography
                        sx={{
                            fontSize: '14px',
                            fontWeight: 600,
                        }}
                        color={theme.palette.dark.main}
                    >
                        Hierarchy
                    </Typography>
                    <Typography sx={{ fontSize: '20px', fontWeight: 400 }}>
                        {hierarchyLevel}
                    </Typography>
                </Grid>
                {/* Partner & PoP */}
                <Grid
                    item
                    lg={6}
                    xs={12}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '24px',
                    }}
                >
                    <Box display="flex" gap="24px" flexDirection="column">
                        <Typography
                            sx={{ fontSize: '14px', fontWeight: 600 }}
                            color={theme.palette.dark.main}
                        >
                            Partner
                        </Typography>
                        <Typography sx={{ fontSize: '20px', fontWeight: 400 }}>
                            {partner ?? 'N/A'}
                        </Typography>
                    </Box>
                    <Box display="flex" gap="24px" flexDirection="column">
                        <Typography
                            sx={{ fontSize: '14px', fontWeight: 600 }}
                            color={theme.palette.dark.main}
                        >
                            Partner of Partner
                        </Typography>
                        <Typography sx={{ fontSize: '20px', fontWeight: 400 }}>
                            {partnerOfPartner ?? 'N/A'}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default UserTypes;
